"use strict";
/**
 * 表单缓存工具
 * 用于在用户未登录时保存表单数据，登录后恢复
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveFormDraft = saveFormDraft;
exports.loadFormDraft = loadFormDraft;
exports.clearFormDraft = clearFormDraft;
exports.hasValidFormDraft = hasValidFormDraft;
/** 缓存 key 前缀 */
const CACHE_KEY_PREFIX = 'common-reservation-draft';
/** 默认过期时间：30 分钟（毫秒） */
const DEFAULT_EXPIRE_MS = 30 * 60 * 1000;
/**
 * 生成缓存 key
 * @param moduleName 模块名称
 * @returns 缓存 key
 */
function getCacheKey(moduleName) {
    return `${CACHE_KEY_PREFIX}-${moduleName}`;
}
/**
 * 保存表单草稿到 localStorage
 * @param moduleName 模块名称
 * @param formData 表单数据
 * @param expireMs 过期时间（毫秒），默认 30 分钟
 */
function saveFormDraft(moduleName, formData, expireMs = DEFAULT_EXPIRE_MS) {
    if (!moduleName) {
        console.warn('[common-reservation] saveFormDraft: moduleName 不能为空');
        return;
    }
    const cacheKey = getCacheKey(moduleName);
    const cacheData = {
        data: formData,
        expireAt: Date.now() + expireMs,
    };
    try {
        localStorage.setItem(cacheKey, JSON.stringify(cacheData));
        console.log('[common-reservation] 表单草稿已保存到 localStorage:', {
            moduleName,
            formData,
            expireAt: new Date(cacheData.expireAt).toLocaleString(),
        });
    }
    catch (error) {
        console.error('[common-reservation] 保存表单草稿失败:', error);
    }
}
/**
 * 从 localStorage 加载表单草稿
 * @param moduleName 模块名称
 * @returns 表单数据，如果不存在或已过期则返回 null
 */
function loadFormDraft(moduleName) {
    if (!moduleName) {
        console.warn('[common-reservation] loadFormDraft: moduleName 不能为空');
        return null;
    }
    const cacheKey = getCacheKey(moduleName);
    try {
        const cachedStr = localStorage.getItem(cacheKey);
        if (!cachedStr) {
            return null;
        }
        const cacheData = JSON.parse(cachedStr);
        // 检查是否过期
        if (Date.now() > cacheData.expireAt) {
            console.log('[common-reservation] 表单草稿已过期，已清除');
            localStorage.removeItem(cacheKey);
            return null;
        }
        console.log('[common-reservation] 已加载表单草稿:', cacheData.data);
        return cacheData.data;
    }
    catch (error) {
        console.error('[common-reservation] 加载表单草稿失败:', error);
        // 解析失败时清除无效数据
        localStorage.removeItem(cacheKey);
        return null;
    }
}
/**
 * 清除表单草稿
 * @param moduleName 模块名称
 */
function clearFormDraft(moduleName) {
    if (!moduleName) {
        console.warn('[common-reservation] clearFormDraft: moduleName 不能为空');
        return;
    }
    const cacheKey = getCacheKey(moduleName);
    try {
        localStorage.removeItem(cacheKey);
        console.log('[common-reservation] 表单草稿已清除');
    }
    catch (error) {
        console.error('[common-reservation] 清除表单草稿失败:', error);
    }
}
/**
 * 检查是否存在有效的表单草稿
 * @param moduleName 模块名称
 * @returns 是否存在有效的草稿
 */
function hasValidFormDraft(moduleName) {
    return loadFormDraft(moduleName) !== null;
}
//# sourceMappingURL=data:application/json;base64,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